import { connect } from "react-redux";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { withStyles } from "@mui/styles";
import styles from "./StreamTargetPage-jss";
import { Button, Grid, Typography } from "@mui/material";
import StreamTargetIntegrations from "../StreamTargetIntegration/StreamTargetIntegrations";
import StreamTargetAccountList from "./StreamTargetAccountList";
import { Dispatch } from "redux";
import Page from "../../components/Page/Page";

type Properties = {
    classes: any,
    onContinue?: () => void,
    onSkip?: () => void,
};

function StreamTargetPage(props: Properties) {
    const {
        classes,
        onContinue,
        onSkip,
    } = props;

    const { t } = useTranslation();

    return (
        <Page title={t('Stream destinations')}>
            <Grid
                item
                container
                alignItems="flex-start"
                direction="row"
                spacing={5}
            >
                <Grid
                    item
                    container
                    alignItems="flex-start"
                    direction="row"
                    spacing={2}
                >
                    <StreamTargetIntegrations />
                </Grid>

                <Grid
                    item
                    container
                    alignItems="flex-start"
                    direction="row"
                    spacing={2}
                >
                </Grid>

                <Grid
                    item
                    container
                    alignItems="flex-start"
                    direction="row"
                    spacing={2}
                >
                    <Typography variant="h5">{t('Accounts')}</Typography>
                    <StreamTargetAccountList />
                </Grid>
                {onContinue && (
                    <Grid item container justifyContent="space-between">
                        {onSkip && (
                            <Button
                                variant="text"
                                size="large"
                                onClick={onSkip}
                            >
                                {t('Skip for now')}
                            </Button>
                        )}
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={onContinue}
                        >
                            {t('Continue')}
                        </Button>
                    </Grid>
                )}
            </Grid>
        </Page>
    );
}

function mapDispatchToProps(dispatch: Dispatch) {
    return {};
}

export default withStyles(styles)(connect(null, mapDispatchToProps)(StreamTargetPage));
